export default "__VITE_ASSET__DVLFz6Hs__"